import { computed } from "vue";
import "./assets/index-CgZzOVq6.js";
import { u as useListeners } from "./assets/index-Ca8wHgNc.js";
import "./assets/index-vzP2cezV.js";
import "vue-demi";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import XFormField from "./XFormField.js";
import { S as SingleInput, e as emits, t as types, b as baseProps, c as changeEvent, a as modelPropName } from "./assets/SingleInput-CTOYPcHF.js";
import MultipleInputs from "./MultipleInputs.js";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "./assets/index-Df_FM1j-.js";
import "./assets/index-BNd8MWnO.js";
import "./assets/index-DKxr0Yto.js";
import "./assets/index-4vIud5LZ.js";
import "./assets/SingleMessage-Dv2wNb7f.js";
import "./assets/XIcon-U9bwokTN.js";
import "@fortawesome/vue-fontawesome";
import "./XLink.js";
import "./assets/BaseLink-KuovKwoP.js";
import "./XTooltip.js";
import "./assets/XDropdown-CrQavYks.js";
import "@floating-ui/dom";
import "./BasicContent.js";
import "./ContentBox.js";
import "./CloseButton.js";
import "./AdvancedContent.js";
import "./MessagesContainer.js";
import "./assets/index-BJV0_gaH.js";
const isFormDisabled = "_isFormDisabled_1ypk7_1";
const style0 = {
  isFormDisabled
};
const __default__ = {
  name: "BaseOption",
  components: { XFormField, SingleInput, MultipleInputs }
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    ...baseProps,
    ...types
  },
  emits,
  setup(__props) {
    const props = __props;
    const isMultiple = computed(() => props.items.length > 0);
    const currentComponentName = computed(() => isMultiple.value ? "MultipleInputs" : "SingleInput");
    const containerTag = computed(() => props.disableForm ? "div" : "XFormField");
    const { v2Listeners } = useListeners(["change"]);
    function getkey() {
      return `key-${props.dataTestid}-${props[modelPropName]}`;
    }
    return { __sfc: true, props, isMultiple, currentComponentName, containerTag, v2Listeners, getkey, changeEvent };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.containerTag, { tag: "component", class: _vm.disableForm && _vm.$style.isFormDisabled, attrs: { "message": _vm.errorMessage } }, [_c(_setup.currentComponentName, _vm._g(_vm._b({ key: _setup.getkey(), tag: "component", attrs: { "type": _vm.type }, on: _vm._d({}, [_setup.changeEvent, ($event) => _vm.$emit(_setup.changeEvent, $event)]) }, "component", { ..._vm.$props, ..._vm.$attrs }, false), _setup.v2Listeners), [_vm._t("default")], 2)], 1);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const BaseOption = __component__.exports;
export {
  BaseOption as default
};
